<script setup>
    import { ElCollapseItem, ElInput, ElCheckbox, ElDatePicker, ElButton } from 'element-plus';
    import { ref } from 'vue'
    import { useProductStore } from '../../stores/fpe'
    import { storeToRefs } from 'pinia';
    import { ArrowRightBold } from '@element-plus/icons-vue'
    const store = useProductStore();
    const { product, data_sets, tax_enabled, strings } = storeToRefs(store);

    const schedule = ref(false);
    const price_error = ref(false);
    const sale_price_error = ref(false);
    const sale_price_error_text = ref('');

    if(product.value.date_on_sale_from != '' || product.value.date_on_sale_to != ''){
        schedule.value = true;
    }

    const sale_from = product.date_on_sale_from;

    const disabledToDate = (date) => {
        
        const current_date = new Date(date);
        const sale_from_date = new Date(product.value.date_on_sale_from);

        if(current_date >= sale_from_date){
            return false;
        }

        return true;
    }

    const validate_price = (value) => {
        const decimalRegex = /^\d*\.?\d*$/;
        if(!decimalRegex.test(value)){
            price_error.value = true;
        }else{
            price_error.value = false;
        }
    }

    const validate_sale_price = (value) =>  {
        const decimalRegex = /^\d*\.?\d*$/;
        if(decimalRegex.test(value)){
            // valid number
            if(value >= parseFloat(product.value.regular_price)){
                sale_price_error.value = true;
                sale_price_error_text.value = strings.value.validation_error_sale_price_higher;
            }else{
                sale_price_error.value = false;
                sale_price_error_text.value = '';
            }
        }else{
            sale_price_error.value = true;
            sale_price_error_text.value = strings.value.validation_error_decimal; 
        }
    }

    const toggleSchedule = (value) => {
        if(value == false){
            product.value.date_on_sale_from = '';
            product.value.date_on_sale_to = '';
        }
    }

</script>

<template>
    <el-collapse-item :title="strings.section_title_price" name="pricing" class="fpe-section-price" v-if="product.type != 'grouped'" :icon="ArrowRightBold">
        <div class="fpe-field-wrapper" data-field="regular-price">
            <label v-html="strings.label_regular_price"></label>
            <ElInput 
                :class="{ fpe_error: price_error }"
                v-model="product.regular_price"
                @input="validate_price"
            />
            <div v-if="price_error" class="error" v-html="strings.validation_error_decimal"></div>
        </div>

        <div class="fpe-field-wrapper" data-field="sale-price">
            <label v-html="strings.label_sale_price"></label>
            <ElInput 
                v-model="product.sale_price" 
                :class="{fpe_error: sale_price_error}"
                @input="validate_sale_price" />
            <div class="error" v-if="sale_price_error" v-html="sale_price_error_text"></div>
        </div>        

        <div class="fpe-field-wrapper fpe_sale_schedule" data-field="sale">
            <label>{{ strings.label_schedule_sale }}</label>
            <ElSwitch v-model="schedule" @change="toggleSchedule"/>    
        </div>

        <div class="fpe-sale-dates" v-if="schedule" data-field="sale-schedule">
            <ElDatePicker
                :class="fpe-date-start"
                v-if="schedule"
                v-model="product.date_on_sale_from"
                :placeholder="strings.placeholder_start_date"
                value-format="YYYY-MM-DD"
                
            />
            
            <ElDatePicker
                :class="fpe-date-end"
                v-if="schedule"
                v-model="product.date_on_sale_to"
                :placeholder="strings.placeholder_end_date"
                :disabled-date="disabledToDate"
                value-format="YYYY-MM-DD"
                
            />
        </div>

        <div class="fpe-field-wrapper" v-if="tax_enabled" data-field="tax-status">
            <label>{{ strings.label_tax_status }}</label>
            <ElSelect v-model="product.tax_status">
                <el-option
                    v-for="(value, name) in Object.entries(data_sets.tax_statuses)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect> 
        </div>

        <div class="fpe-field-wrapper" v-if="tax_enabled" data-field="tax-class">
            <label>{{ strings.label_tax_class }}</label>
            <ElSelect v-model="product.tax_class">
                <el-option
                    v-for="(value, name) in Object.entries(data_sets.tax_classes)"
                    :key="value[0]"
                    :label="value[1]"
                    :value="value[0]"
                />
            </ElSelect> 
        </div>
            

    </el-collapse-item>
</template>